import { render, staticRenderFns } from "./updatePriceModal.vue?vue&type=template&id=8176cdd0&scoped=true&"
import script from "./updatePriceModal.vue?vue&type=script&lang=js&"
export * from "./updatePriceModal.vue?vue&type=script&lang=js&"
import style0 from "./updatePriceModal.vue?vue&type=style&index=0&id=8176cdd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8176cdd0",
  null
  
)

export default component.exports